import { LexicalEditorWrapper } from 'components/richText'
import {
  ImageNode,
  MentionNode,
  SlashCommandNode,
} from 'features/richText/nodes'
import React from 'react'
import { EditorMode, RichTextContent } from 'types'

/**
 * Props for the RichTextViewer component.
 *
 * @property content - The rich text content to display.
 * @property className - Optional CSS class for the viewer container.
 * @property emptyMessage - Fallback message to display when content is empty.
 * @property interactive - Whether to allow interaction with embedded objects.
 */
export interface RichTextViewerProps {
  content: RichTextContent
  className?: string
  emptyMessage?: string
  interactive?: boolean
}

export const RichTextViewer: React.FC<RichTextViewerProps> = ({
  content,
  className,
  emptyMessage = 'No content',
}) => {
  const customNodes = [MentionNode, SlashCommandNode, ImageNode]

  // Handle empty content
  if (!content || !content.trim()) {
    return (
      <div
        className={className}
        style={{
          color: 'var(--secondary-text)',
          fontStyle: 'italic',
          padding: '0.5rem 0',
        }}>
        {emptyMessage}
      </div>
    )
  }

  return (
    <LexicalEditorWrapper
      value={content}
      className={className}
      mode={EditorMode.VIEW}
      readOnly={true}
      nodes={customNodes}
      richText={true}
      minHeight='auto'
    />
  )
}
